var map = {
	"./2004_cover.jpg": 406,
	"./2005_cover.jpg": 444,
	"./2006_cover.jpg": 229,
	"./2007_cover.jpg": 149,
	"./2008_cover.jpg": 260,
	"./2009_cover.jpg": 564,
	"./2010_cover.jpg": 37,
	"./2011_cover.jpg": 373,
	"./2012_cover.jpg": 932,
	"./2013_cover.jpg": 280,
	"./2014_cover.jpg": 460,
	"./2015_cover.jpg": 757,
	"./2016_cover.jpg": 363,
	"./2017_cover.jpg": 82,
	"./2018_cover.jpg": 40,
	"./2019_cover.jpg": 130,
	"./2020_cover.jpg": 743,
	"./2021_cover.jpg": 443,
	"./2022_cover.jpg": 456,
	"./2023_cover.jpg": 882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 719;